import wrapperMediator from 'slotworks/integration/revolver/wrapper/wrapper-mediator';
import gameState from 'slotworks/model/game-state';
import Gameplay from 'slotworks/model/gameplay/gameplay-model';
import Record from 'slotworks/model/gameplay/records/record';
import { RecordBuilder } from 'slotworks/server/builders/record-builder';
import { DOServerKeys } from '../names/do-names';
import PickOneTreasureBonusRecord from './pickone-treasure-bonus-record';
import { PatsPaydayResponseSchema } from './response-schema';

class BonusRecordBuilder implements RecordBuilder {
    public bonusId: string;

    public filter(data: any): boolean {
        let pickResponse: PatsPaydayResponseSchema;

        if (data && data.data) {
            pickResponse = data.data as PatsPaydayResponseSchema;
        }
        return pickResponse && pickResponse.RESULTS !== undefined && pickResponse.RESULTS.game === DOServerKeys.TREASURE_BONUS;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let pickResponse: PatsPaydayResponseSchema;

        if (data && data.data) {
            pickResponse = data.data as PatsPaydayResponseSchema;
        }

        const record = gameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
        let bonusRecord = r[0];
        let isThere: boolean = true;
        if (!bonusRecord) {
            bonusRecord = new PickOneTreasureBonusRecord();
            isThere = false;
        }
        bonusRecord.is_complete = pickResponse.RESULTS.state.is_complete;
        bonusRecord.triggered = pickResponse.RESULTS.state.triggering_game != DOServerKeys.TREASURE_BONUS && pickResponse.RESULTS.next_game === DOServerKeys.TREASURE_BONUS;
        bonusRecord.pickedOptions = pickResponse.RESULTS.state.pickedOptions;
        bonusRecord.rounds = pickResponse.RESULTS.state.rounds;
        bonusRecord.total_win_cash = pickResponse.RESULTS.state.total_win_cash;

        const win = parseFloat(pickResponse.RESULTS.total_win_cash as any);
        gameplay.totalCreditsWon += win;
        gameState.updateNetPosition(win);
        gameplay.totalFreespinsCreditsWon += win;
        wrapperMediator.roundEnd(win, 0, gameplay.balance);

        if (isThere) {
            (record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[])[0] = bonusRecord;
        } else {
            record.results.push(bonusRecord);
        }
        return [record];
    }
}

export default new BonusRecordBuilder();



// WEBPACK FOOTER //
// ./src/integration/bonus-record-builder.ts